module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/SwelteringNight/Tokyo_SwelteringNight_MRI_RCP85_End.png";